import store from "../../../../../../../../store";
import {setSQFTActiveButton, setSQFTMenuOpened, setSQFTPopup} from "../../../../../../../../actions/sqftMenuFunctions";
import workspace from "../../../../../canvas/core/workspace";
import {SQFT_FEATURES} from "../../../../../../constants";

class OverlayNo3dNotifier {
  constructor(viewer) {
    this.viewer = viewer;
  }

  showNo3D() {
    store.dispatch(setSQFTPopup({
      title: workspace.intl.formatMessage({ id: "sqft.popup.title.systemMessage" }),
      content: 'No 3D products available for your current selections.\n' +
        'Please select another product from your tools menu.',
      isOpened: true,
      additionalClasses: 'message-box-medium',
      confirmCallback: () => {},
      confirmText: '',
      cancelCallback: () => {
        this.hide();
        const state = store.getState();
        const sqftMenuOpened = state.sqftMenuState.menuOpened;

        if (sqftMenuOpened !== SQFT_FEATURES.bottom_cabinet) {
          store.dispatch(setSQFTMenuOpened(SQFT_FEATURES.bottom_cabinet));
          store.dispatch(setSQFTActiveButton(SQFT_FEATURES.bottom_cabinet));
        }
      },
      cancelText: ''
    }));
  }

  hide() {
    store.dispatch(setSQFTPopup({
      title: workspace.intl.formatMessage({ id: "sqft.popup.title.systemMessage" }),
      content: '',
      isOpened: false,
      confirmCallback: () => {},
      confirmText: '',
      cancelCallback: () => {},
      cancelText: ''
    }));
  }
}

export default OverlayNo3dNotifier
